module.exports = __webpack_public_path__ + "img/logo-icon.ca07e6e0.png";